import { type ReactNode } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import {
  Modal,
  Button,
  Upload,
  Typography,
  Flex,
  UploadFile,
} from "antd";
import { DocFolderIcon } from "@/shared/assets/svg/icons";
import "./mass-upload-modal.scss";

interface IMassUploadModal {
  isModalOpen: boolean;
  handleCancel: () => void;
}

const documentSections = [
  "Разрешительная документация",
  "Проектная документация",
  "Рабочая документация",
  "Исполнительные схемы",
  "Документы подтверждающие качество",
  "Лаборатории",
  "Сопроводительные документы",
];

function MassUploadFileItem(
  _: ReactNode,
  file: UploadFile,
  __: UploadFile[],
  actions: { remove: () => void },
) {
  return (
    <div className="mass-upload-modal__file-item">
      <Flex gap="small">
        <span>{file.name}</span>
      </Flex>
      <DeleteOutlined
        style={{ cursor: "pointer" }}
        onClick={() => actions.remove()}
      />
    </div>
  );
}

export function MassUploadModal({
  isModalOpen,
  handleCancel,
}: IMassUploadModal) {
  return (
    <Modal
      centered
      title={
        <Flex justify="space-between" align="center" style={{ width: "92%" }}>
          <Typography.Title level={3} style={{ margin: 0 }}>
            Массовая загрузка
          </Typography.Title>
          <Typography.Text
            style={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "20px",
              color: "#4169E1",
              cursor: "pointer",
            }}
          >
            Скачать Excel шаблон
          </Typography.Text>
        </Flex>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      style={{ minWidth: "640px", paddingTop: "24px", paddingBottom: "24px" }}
    >
      <Flex vertical gap="middle">
        <Flex
          vertical
          style={{
            width: "100%",
            padding: "16px",
            border: "1px dashed #BCBFC0",
            borderRadius: "16px",
            gap: "16px",
          }}
        >
          <Typography.Text>
            Загрузите заполненную таблицу с компьютера. <br /> .xls формат до
            10МБ
          </Typography.Text>
          <Upload
            accept=".xls,.xlsx"
            showUploadList={{
              showPreviewIcon: false,
              showRemoveIcon: true,
              showDownloadIcon: false,
            }}
            itemRender={MassUploadFileItem}
            beforeUpload={() => false}
          >
            <Button type="primary">Выбрать EXEL таблицу</Button>
          </Upload>
        </Flex>
        <Typography.Text>
          В каждой папке файлы должны соответствовать своему разделу
        </Typography.Text>
        <Flex vertical>
          {documentSections.map((section) => (
            <Flex key={section} gap="small" style={{ padding: "8px 0" }}>
              <DocFolderIcon />
              <Typography.Text style={{ color: "#4169E1" }}>
                {section}
              </Typography.Text>
            </Flex>
          ))}
        </Flex>
        <ul className="mass-upload-modal__notes-list">
          <li>
            Если названия файла нет в таблице - этот файл будет проигнорирован.
          </li>
          <li>
            Если не заполнены все необходимые поля - этот файл не загрузится.
          </li>
          <li>Файлы с полностью идентичными данными загружены не будут.</li>
        </ul>
      </Flex>
    </Modal>
  );
}
